var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1770362540355,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1752,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M699.68 224.48l3.712-0.192a32 32 0 0 1 31.808 28.256l0.192 3.744v159.68L800 416a128 128 0 0 1 128 128v320.704c16.64 0 30.176 12.352 32 28.288l0.256 3.712a32 32 0 0 1-28.288 31.808l-3.744 0.192H96.096a32 32 0 0 1 0-64h-0.128L96 544a128 128 0 0 1 128-128h63.36l0.032-159.712a32 32 0 0 1 28.288-31.808l3.712-0.192a32 32 0 0 1 31.808 28.256l0.192 3.744v159.68h128V256.32a32 32 0 0 1 28.288-31.808l3.712-0.192a32 32 0 0 1 31.808 28.256l0.192 3.744v159.68h128V256.32a32 32 0 0 1 28.288-31.808l3.712-0.192zM682.56 711.36c-56.8 30.528-113.984 45.984-171.328 45.984-57.184 0-113.792-15.36-169.44-45.792-35.392 30.08-72.096 45.792-109.952 45.792-24.64 0-48.608-6.656-71.872-19.584V864h704v-125.952c-22.944 12.736-46.624 19.296-71.04 19.296-37.824 0-74.656-15.776-110.368-45.984zM800 480h-92.48a32.32 32.32 0 0 1-8.192 0h-183.84a32.32 32.32 0 0 1-8.16 0h-183.84a32.32 32.32 0 0 1-8.16 0H224a64 64 0 0 0-64 64v114.624c25.408 23.68 49.28 34.72 71.872 34.72 23.744 0 49.344-12.128 76.992-38.144l5.952-5.792 17.92-17.952 21.536 13.312c52.736 32.576 104.928 48.576 156.992 48.576 48.704 0 98.08-13.984 148.416-42.432l10.816-6.304 21.376-12.928 17.728 17.6c30.272 30.112 58.016 44.064 83.36 44.064 22.464 0 46.048-10.976 71.04-34.592V544a64 64 0 0 0-64-64zM512 96a32 32 0 1 1 0 64 32 32 0 0 1 0-64z m192 0a32 32 0 1 1 0 64 32 32 0 0 1 0-64zM320 96a32 32 0 1 1 0 64 32 32 0 0 1 0-64z",
    fill: "#707070",
    "p-id": 1753
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.afca559e.svg";
export { ForwardRef as ReactComponent };